export default '/assets/imgs/wallpaper/bliss.jpg';